import React from 'react';

// CSS for custom Split pane
import './SplitPane.scss';

// react-splitter-layout
import SplitterLayout from 'react-splitter-layout';
import 'react-splitter-layout/lib/index.css';

export const SplitPane = ({
  children,
  split = 'vertical',
  defaultSize = 350,
  library = 'none',
}) => (
  <SplitterLayout
    vertical={split === 'horizontal'}
    secondaryInitialSize={defaultSize}
    secondaryMinSize={defaultSize}
    className=""
  >
    {children}
  </SplitterLayout>
);
